import { format, parseISO } from "date-fns";

import { i18n } from "../translate/i18n";

// Cores do score (spec F1): >=80 verde, >=60 amarelo, senão vermelho.
export const scoreColor = (score) => {
  const n = Number(score) || 0;
  if (n >= 80) return "#0F766E";
  if (n >= 60) return "#B7791F";
  return "#E5484D";
};

export const temperatureColor = (temperature) => {
  if (temperature === "quente") return "#E5484D";
  if (temperature === "morno") return "#B7791F";
  return "#2563EB";
};

export const outcomeColor = (outcome) => {
  if (outcome === "ganhou") return "#0F766E";
  if (outcome === "perdeu") return "#E5484D";
  if (outcome === "negociando") return "#B7791F";
  return "#6B7280";
};

// Badge do score (v2): >=80 Excelente, >=60 Bom, senão Ruim.
export const scoreBadgeKey = (score) => {
  const n = Number(score) || 0;
  if (n >= 80) return "excelente";
  if (n >= 60) return "bom";
  return "ruim";
};

// Veredito da IA por mensagem (messageComments).
export const verdictColor = (verdict) => {
  if (verdict === "good") return "#0F766E";
  if (verdict === "warn") return "#B7791F";
  return "#E5484D"; // bad
};

// Tipo de evento importante (events).
export const eventKindColor = (kind) => {
  if (kind === "good") return "#0F766E";
  if (kind === "warn") return "#B7791F";
  if (kind === "bad") return "#E5484D";
  return "#6B7280"; // neutral
};

// Emoção do cliente (emotions).
export const emotionColor = (emotion) => {
  if (emotion === "irritado") return "#E5484D";
  if (emotion === "confuso") return "#F5A623";
  if (emotion === "tranquilo") return "#4CAF8E";
  if (emotion === "satisfeito") return "#0F766E";
  return "#98A2B3"; // neutro
};

// Impacto de problema (issues).
export const impactColor = (impact) => {
  if (impact === "alto") return "#E5484D";
  if (impact === "medio") return "#EA580C";
  return "#B7791F"; // baixo
};

// Ordem fixa do funil (6 etapas sempre).
export const STAGE_ORDER = [
  "abordagem",
  "descoberta",
  "oferta",
  "objecao",
  "fechamento",
  "pos_venda",
];

const label = (path, value) =>
  value ? i18n.t(`saleAudit.${path}.${value}`, { defaultValue: value }) : "—";

export const stageLabel = (stage) => label("stages", stage);
export const temperatureLabel = (temperature) =>
  label("temperatures", temperature);
export const outcomeLabel = (outcome) => label("outcomes", outcome);
export const scoreBadgeLabel = (score) => label("badges", scoreBadgeKey(score));
export const verdictLabel = (verdict) => label("verdicts", verdict);
export const eventKindLabel = (kind) => label("kinds", kind);
export const emotionLabel = (emotion) => label("emotions", emotion);
export const impactLabel = (impact) => label("impacts", impact);
export const levelLabel = (level) => label("levels", level);
export const vsTeamLabel = (vsTeam) => label("vsTeam", vsTeam);

// Valores são sempre R$ (pt-BR), independente do idioma da UI.
const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export const formatBRL = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return brl.format(n);
};

export const formatPercent = (value) => `${Math.round(Number(value) || 0)}%`;

// Data/hora curtas pt-BR (ex.: 29/07 09:32); backend pode mandar null.
export const formatShortDateTime = (value) => {
  if (!value) return "—";
  try {
    return format(parseISO(value), "dd/MM HH:mm");
  } catch {
    return "—";
  }
};
